<template>
  <div id="crear-expediente">
    <v-form ref="crearExpediente" v-model="esformularioValido">
      <!-- <v-card> -->
        <!-- <v-card-title class="secondary--text">
          Crear Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title> -->
        <!-- <v-card-text> -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-tbody">
          </v-skeleton-loader>
          <div v-else>
            <v-data-table
              :headers="headers"
              :items="getDocumentos"
              :search="buscarDocumento"
              :items-per-page="itemsPerPage"
              hide-default-footer
              >
              <template v-slot:[`item.agregar`]="{ item }">
                <v-row justify="end">
                    <v-checkbox
                    class="my-0 py-0"
                    v-model="documentosSeleccionados"
                    :value="item"
                    dense>
                    </v-checkbox>
                </v-row>
              </template>
            </v-data-table>
          </div>
        <!-- </v-card-text> -->
      <!-- </v-card> -->
    </v-form>
  </div>
</template>

<script>
// import CustomButton from '@/components/buttons/Button.vue';
// import CustomTextField from '@/components/inputs/TextField.vue';
import mixExpedientes from './mixExpedientes';

// import eventBus from '@/helpers/eventBus';

export default {
  name: 'CrearExpediente',
  mixins: [mixExpedientes],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    moduloExpedienteOrigen: {
      type: String,
      required: true,
    },
    catalogoExpediente: {
      type: Array,
      required: true,
    },
    tipoDeContrato: {
      type: String,
      required: false,
    },
    buscarDocumento: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    // CustomTextField,
    // CustomButton,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      itemsPerPage: -1,
      documentosSeleccionados: [],
      headers: [
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        {
          text: 'Agregar', align: 'end', width: '120', value: 'agregar',
        },
      ],
    };
  },
  methods: {
    crearExpediente() {
      this.mixCrearExpediente();
    },
    setIdReferencia() {
      switch (this.moduloExpedienteOrigen) {
        case 'contratos':
          this.expediente.idContrato = this.idReferencia;
          break;
        case 'obra':
          this.expediente.idObra = this.idReferencia;
          break;
        case 'licitacion':
          this.expediente.idLicitacion = this.idReferencia;
          break;
        case 'adjudicacionDirecta':
          this.expediente.idAdjudicacionDirecta = this.idReferencia;
          break;
        default: break;
      }
    },
    setDocumentos() {
      const documentos = this.getDocumentos;
      this.documentosSeleccionados = documentos;
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.crearExpediente.reset();
    },
  },
  computed: {
    getDocumentos() {
      return this.getCatalogoExpediente;
    },
    getCatalogoExpediente() {
      if (this.tipoDeContrato === 'OBRA') {
        return this.catalogoExpediente
          .filter((expediente) => expediente.esObra);
      }
      if (this.tipoDeContrato === 'SERVICIO') {
        return this.catalogoExpediente
          .filter((expediente) => expediente.esServicio);
      }
      return this.catalogoExpediente;
    },
  },
  mounted() {
    this.setDocumentos();
  },
  watch: {
    esformularioValido: {
      handler(esformularioValido) {
        this.$emit('formularioValido', esformularioValido);
      },
    },
    enviandoFormulario: {
      handler(enviandoFormulario) {
        this.$emit('enviandoFormulario', enviandoFormulario);
      },
    },
  },

};
</script>

<style>

</style>
